import { remove } from "lodash";

export class AssessmentLookup {


    static GetRequired(id: number): string {
        switch (id) {
            case (1): return "Yes";
            case (2): return "No";
            default: return "Unknown";
        }
    }

    static GetVisitStatus(id: number): string {
        switch (id) {
            case (1): return "Completed";
            case (2): return "Not Yet Due";
            case (3): return "Overdue";
            case (4): return "Not Done";
            case (5): return "Discontinued Prior";
            case (6): return "Not Yet Due (≤30 Days)";
            case (7): return "Not Yet Due (+30 Days)";
            case (20): return "In Window";
            case (21): return "± 1 - 3 Days";
            case (22): return "± 4 - 7 Days";
            case (23): return "± 8 - 14 Days";
            case (24): return "15+ Days";
            default: return "Unknown";
        }
    }

    static GetVisitColorIndex(id: number): number {
        switch (id) {
            case (1): return 500; //Completed
            case (2): return 501; //Not Yet Due
            case (3): return 502; //Overdue
            case (4): return 503; //Not Done
            case (5): return 504; //Discontinued Prior
            case (6): return 501; //Not Yet Due <= 30 Days
            case (7): return 505; //Not Yet Due > 30 Days
            case (20): return 500; //In Window
            case (21): return 501; //1 to 3 Days Outside Window
            case (22): return 502; //4 to 7 Days Outside Window
            case (23): return 503; //8 to 14 Days Outside Window
            case (24): return 504; //15 or More Days Outside Widow
            default: return 0;
        }
    }

    static GetAssessmentColumn(id: number): string {
        switch (id) {
            case 1: return "COMPASS_31";
            case 2: return "CTCSQ";
            case 3: return "DSQ_PEM";
            case 4: return "DSQ_PEM_SLV";
            case 5: return "ECOG_2";
            case 6: return "ESWT";
            case 7: return "ISWT";
            case 8: return "NB";
            case 9: return "OHQ";
            case 10: return "PASC";
            case 11: return "PRM29";
            case 12: return "PRM8a";
            case 13: return "PRM8a_SRI";
            case 14: return "PRM8b_SD";
            case 15: return "PROMIS_F";
            case 16: return "SGAQ";;
            case 17: return "Active Stand Test"
            default: return "Unknown";
        }
    }

    static GetNameColumn(id: number): string {
        switch (id) {
            case 1: return "Compass 31";
            case 2: return "Modified DePaul Symptom Questionnaire - PEM (Last 7 Days)";
            case 3: return "Active Stand Test";
            case 4: return "Modified DePaul Symptom Questionnaire - PEM (Last Visit)";
            case 5: return "Malmo Pots Symptom Score";
            case 6: return "Orthostatic Hypotension Questionnaire";
            case 7: return "PASC Symptom Questionnaire";
            case 8: return "PROMIS-29+2";
            case 9: return "Vanderbilt Orthostatic Symptoms Score";
            case 10: return "Everyday Cognition 2";
            case 11: return "Neurocognitive Battery";
            case 12: return "PROMIS-Cognitive 8a";
            case 13: return "PROMIS-8a SRI";
            case 14: return "PROMIS-8b SD";
            case 15: return "PROMIS-Fatigue";
            case 16: return "Subjective Global Assessment Questionnaire";
            case 17: return "Modified DePaul Symptom Questionnaire - PEM (3 Months)";
            case 18: return "EQ-5D-5L";
            case 19: return "Endurance Shuttle Walk Test";
            case 20: return "Hours of Upright Activity";
            case 21: return "Incremental Shuttle Walk Test";
            case 22: return "Modified Medical Research Council (mMRC) Dyspnea Scale";
            case 23: return "Modified Orthostatic Hypotension Questionnaire";
            case 24: return "Patient Global Impression of Change";
            case 25: return "PROMIS Short Form Physical Function 8b";
            case 26: return "Auditory Verbal Learning Test";
            case 27: return "Insomnia Severity Index";
            case 28: return "PROMIS Fatigue Short Form 10a";
            case 29: return "Patient Global Impression of Severity";
            case 30: return "Split Week Sleep Assessment of Sleep";
            case 31: return "Symbol Digit Modalities Test";
            default: return "Unknown";
        }
    }

    static GetAssessmentOrdering(id: number): number {
        switch (id) {
            case 3: return 1;    // Active Stand Test
            case 26: return 2;   // Auditory Verbal Learning Test
            case 1: return 3;    // Compass 31
            case 18: return 4;   // EQ-5D-5L
            case 19: return 5;   // Endurance Shuttle Walk Test
            case 10: return 6;    // Everyday Cognition 2
            case 20: return 7;   // Hours of Upright Activity
            case 21: return 8;   // Incremental Shuttle Walk Test
            case 27: return 9;    // Insomnia Severity Index
            case 5: return 10;  // Malmo Pots Symptom Score
            case 2: return 11; //"Modified DePaul Symptom Questionnaire - PEM (Last 7 Days)"
            case 17: return 12;  // Modified DePaul Symptom Questionnaire - PEM (3 Months)
            case 4: return 13;   // Modified DePaul Symptom Questionnaire - PEM (Last Visit)
            case 22: return 14;  // Modified Medical Research Council (mMRC) Dyspnea Scale
            case 23: return 15;  // Modified Orthostatic Hypotension Questionnaire
            case 11: return 16;  // Neurocognitive Battery
            case 6: return 17;   // Orthostatic Hypotension Questionnaire
            case 7: return 18;   // PASC Symptom Questionnaire
            case 24: return 19;  // Patient Global Impression of Change
            case 29: return 20;  // Patient Global Impression of Severity
            case 8: return 21;   // PROMIS-29+2
            case 13: return 22;  // PROMIS-8a SRI
            case 14: return 23;  // PROMIS-8b SD
            case 12: return 24;  // PROMIS-Cognitive 8a
            case 15: return 25;  // PROMIS-Fatigue
            case 28: return 26;  // PROMIS Fatigue Short Form 10a
            case 25: return 27;  // PROMIS Short Form Physical Function 8b
            case 30: return 28;  // Split Week Sleep Assessment of Sleep
            case 31: return 29;  // Symbol Digit Modalities Test
            case 16: return 30;  // Subjective Global Assessment Questionnaire
            case 9: return 31;   // Vanderbilt Orthostatic Symptoms Score
            default: return 999; // fallback
        }
    }

    static GetTimepointColumn(id: number): string {
        switch (id) {
            case 1: return "Baseline";
            case 2: return "Day 45";
            case 3: return "Day 60";  
            case 4: return "Day 90";
            case 5: return "Day 120";
            case 6: return "End of Intervention";
            case 7: return "End of Day";
            case 8: return "End of Study";
            case 9: return "Mid-Intervention";
            case 10: return "Screening";
            case 11: return "Week 1";
            case 12: return "Week 1.5";
            case 13: return "Week 2";
            case 14: return "Week 2.5";
            case 15: return "Week 3";
            case 16: return "Week 3.5";
            case 17: return "Week 4/Month 1";
            case 18: return "Week 4.5";
            case 19: return "Week 5";
            case 20: return "Week 5.5";
            case 21: return "Week 6";
            case 22: return "Week 6.5";
            case 23: return "Week 7";
            case 24: return "Week 7.5";
            case 25: return "Week 8";
            case 26: return "Week 8.5";
            case 27: return "Week 9";
            case 28: return "Week 9.5";
            case 29: return "Week 10";
            case 30: return "Week 10.5";
            case 31: return "Week 11";
            case 32: return "Week 11.5";
            case 33: return "Week 12";
            case 34: return "Week 13";
            case 35: return "Week 14";
            case 36: return "Week 15";
            case 37: return "Week 16";
            case 38: return "Week 17";
            case 39: return "Week 18";
            case 40: return "Week 19";
            case 41: return "Week 20";
            case 42: return "Week 21";
            case 43: return "Week 22";
            case 44: return "Week 23";
            case 45: return "Week 24";
            case 46: return "Week 25";
            case 47: return "Week 26";
            case 48: return "Week 27";
            //case 49: return "Month 1";
            case 50: return "Month 3";
            case 51: return "Month 6";
            case 52: return "Follow-Up";
            default: return "Unknown";
        }
    }

    static GetTimepointOrdering(id: number): number {
        switch (id) {
            case 10: return 1;  // SCREEN
            case 1: return 2;   // BASE
            case 9: return 3;   // MOI
            case 6: return 4;   // EOI
            case 2: return 5;   // D045
            case 3: return 6;   // D060
            case 4: return 7;   // D090
            case 5: return 8;   // D120
            case 7: return 9;   // EOD
            case 8: return 10;  // EOS
            case 11: return 11; // WEEK 1
            case 12: return 12; // WEEK 1.5
            case 13: return 13; // WEEK 2
            case 14: return 14; // WEEK 2.5
            case 15: return 15; // WEEK 3
            case 16: return 16; // WEEK 3.5
            case 17: return 17; // WEEK 4
            case 18: return 18; // WEEK 4.5
            case 19: return 19; // WEEK 5
            case 20: return 20; // WEEK 5.5
            case 21: return 21; // WEEK 6
            case 22: return 22; // WEEK 6.5
            case 23: return 23; // WEEK 7
            case 24: return 24; // WEEK 7.5
            case 25: return 25; // WEEK 8
            case 26: return 26; // WEEK 8.5
            case 27: return 27; // WEEK 9
            case 28: return 28; // WEEK 9.5
            case 29: return 29; // WEEK 10
            case 30: return 30; // WEEK 10.5
            case 31: return 31; // WEEK 11
            case 32: return 32; // WEEK 11.5
            case 50: return 33; // 3 Months
            case 33: return 34; // WEEK 12
            case 34: return 35; // WEEK 13
            case 35: return 36; // WEEK 14
            case 36: return 37; // WEEK 15
            case 37: return 40; // WEEK 16
            case 38: return 41; // WEEK 17
            case 39: return 42; // WEEK 18
            case 51: return 43; // Six Months
            case 40: return 44; // WEEK 19
            case 41: return 45; // WEEK 20
            case 42: return 46; // WEEK 21
            case 43: return 47; // WEEK 22
            case 44: return 48; // WEEK 23
            case 45: return 49; // WEEK 24
            case 46: return 50; // WEEK 25
            case 47: return 51; // WEEK 26
            case 48: return 52; // WEEK 27
            default: return 100; // Unknown
        }
    }


    static GetStatusColumn(id: number): string {
        switch (id) {
            case 1: return "Completed";
            case 2: return "Discontinued Prior";
            case 3: return "Missing";
            case 4: return "Not Expected - Cluster-Specific Assessment";
            case 5: return "Not Yet Due";
            case 6: return "Overdue";
            case (20): return "100%";
            case (21): return "80% to < 100%";
            case (22): return "60% to < 80%";
            case (23): return "40% to < 60%";
            case (24): return "< 40%";
            default: return "Unknown";
        }
    }

    static GetAssessmentStatusColorIndex(id: number): number {
        switch (id) {
            case 1: return 500; // Completed
            case 2: return 504; // Discontinued Prior
            case 3: return 503; // Missing
            case 4: return 505; // Not Expected - Cluster-Specific Assessment
            case 5: return 501; // Not yet due
            case 6: return 502; // Overdue
            case (20): return 500; // 100%
            case (21): return 501; // 80% to < 100%
            case (22): return 502; // 60% to < 80%
            case (23): return 503; // 40% to < 60%
            case (24): return 504; // < 40%
            default: return 0;   
        }
    }

    static CompletionStatusColumn(id: number): string {
        switch (id) {
            case 1: return "Fully Completed";
            case 2: return "Partially Completed";
            default: return "Unknown";
        }
    }
}